import React from "react";
import { Chart } from "react-google-charts";
import $ from "jquery";
import "./piechartstyle.css";
let task = [];
let segmentNames = [];
let tableData = [];
class DonutChart extends React.Component {
  constructor(props) {
    super(props);
    task = [];
    segmentNames = [["Segment", "Audience Members"]];
    this.state = {
      segmentData: this.props.segmentsData,
    };
    let sData = $.isArray(this.props.segmentsData)
      ? this.props.segmentsData
      : [];
    // if (sName.indexOf("Remainder") == -1) {
    // 	sName.push('Remainder')
    // }
    tableData = [
      [
        { type: "string", label: "Segment" },
        { type: "string", label: "Name" },
        {
          type: "number",
          label: "Customers",
        } /*,{ type: 'string', label: '%' }*/,
      ],
    ];
    let seg_totals = 0;
    let segHelpCount = 0;
    for (var i = 0; i < sData.length; i++) {
      let x = [];
      let seg_name = sData[i].segment;
      let seg_val = sData[i].count;
      seg_totals += parseInt(sData[i].count);
      let seg_help = "";
      if (seg_name == "Remainder") {
        seg_help = "R";
        x.push("R");
        x.push(parseInt(sData[i].count));
        segmentNames.push(x);
      } else {
        seg_help = (segHelpCount + 1).toString();
        x.push(seg_help);
        x.push(parseInt(sData[i].count));
        segmentNames.push(x);
        segHelpCount++;
      }
      /*let seg_perc = 0;
			if (this.props.filteredAudience != "" && this.props.filteredAudience != " ") {
				seg_perc = (seg_val/this.props.filteredAudience*100).toFixed(1) + '%'
			} else {
				seg_perc = 'Please wait...'
			}*/
      //tableData.push([seg_help, seg_name, seg_val, seg_perc]);
      tableData.push([seg_help, seg_name, seg_val]);
    }
  }

  render() {
    return (
      <React.Fragment>
        <Chart
          chartType="PieChart"
          width="auto"
          data={segmentNames}
          options={{
            legend: { position: "none" },
            pieSliceText: "label",
            sliceVisibilityThreshold: 0,
            colors: [
              // "#f5801f",
              "#69ff45",
              "#808080",
              "#6691c6",
              "#b4413e",
              "#6d833d",
              "#7e60a0",
              "#ffff47",
              "#d30fae",
              "#3599b8",
              "#dfbfbf",
              "#4ac5bb",
              "#5f6b6d",
              "#fb8281",
              "#f4d25a",
              "#7f898a",
              "#a4ddee",
              "#fdab89",
              "#b687ac",
              "#28738a",
              "#a78f8f",
              "#168980",
              "#293537",
              "#bb4a4a",
              "#b59525",
              "#475052",
            ],
            chartArea: { width: "100%", height: "90%" },
          }}
        />
        <Chart
          chartType="Table"
          data={tableData}
          rootProps={{ "data-testid": "1" }}
          options={{
            sortColumn: 0,
            sortAscending: true,
          }}
        />
      </React.Fragment>
    );
  }
}

export default DonutChart;



// WEBPACK FOOTER //
// ./src/views/Audiences/PieChart.jsx